<template>
  <div class="wrapper">
    <div class="circle" :style="style">
      <i class="mainIcon" :class="icon" :style="{ color }"></i>
      <div class="bgcircle" :style="{ opacity: 0.2, background: color }"></div>
    </div>
    <div class="text">
      <DigitalTransform
        :value="value"
        :interval="interval"
        :dislocation="true"
        :useGrouping="false"
        class="value"
      ></DigitalTransform>
      <small>{{ type }}</small>
      <small class="secondLine">{{ optional }}</small>
    </div>
  </div>
</template>
<style scoped>
div.circle {
  width: 80px;
  height: 60px;
  display: inline-block;
  border: 1px solid white;
  border-radius: 60px;
  padding: 5px;
  /* padding-right: 90px; */
  line-height: 12px;
  margin: 10px;
  margin-right: 2px;
  margin-left: 2px;
  margin-bottom: 2px;
  position: relative;
  text-align: center;
  transition: 0.35s all ease;
  /* filter: grayscale(70%); */
  position: relative;
}

div.bgcircle {
  position: absolute;
  z-index: 0;
  top: 0px;
  bottom: 0px;
  left: 10px;
  right: 10px;
  border-radius: 35px;
}
div.circle i {
  font-size: 30px;
}
.mainIcon {
  font-size: 44px;
  padding-top: 15px;
}
.text {
  /* margin-top: 45px; */
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  font-weight: 500;
  /* height: 30px; */
  color: #888;
}
.text small {
  display: block;
  margin-top: -3px !important;
}
.value {
  font-size: 16px;
  /* margin-bottom: 20px; */
  font-weight: 500;
  margin-top: 5px !important;
  display: inline-block !important;
  color: #242424;
}
.wrapper {
  display: inline-block;
}
small.secondLine {
  min-height: 19px;
}
</style>
<script>
import DigitalTransform from "vue-digital-transform";
export default {
  name: "singleBlock",
  data() {
    return {
      active: false,
      style: {
        background: this.background,
        color: this.color,
      },
      interval: 300,
    };
  },
  components: {
    DigitalTransform,
  },
  props: ["icon", "type", "color", "background", "value", "optional"],
  methods: {
    toggle() {
      // this.$emit("toggle", this.type);
    },
  },
};
</script>
